<template>
  <div>
      
      <v-card>
         <v-card-title class="title">{{title}}</v-card-title>

          <v-card-text>
            <v-row >
        
              <v-col>
                  <v-text-field align-self="center"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-col>
            </v-row>


             <v-row>
              <v-col v-if="!filter.isDefaults" class="d-flex align-center">
                  
                </v-col>
                 <v-col class="d-flex"  v-if="!filter.isDefaults">
                      <v-spacer></v-spacer>
                      <v-switch v-model="filter.isDeleted" label="Show Deleted Bookings" class="pa-3"></v-switch>

                </v-col>
 
          
        
             </v-row>
        
</v-card-text>
<v-divider></v-divider>
        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
          :search="search"
          :sort-by="['market_date']"
          :sort-desc="true"
          :must-sort="true"
          :loading="isLoading"
          :custom-sort="customBookingsSort"
        >
          <template v-slot:item.name="{ item }">
            {{ item.name }}
            <!-- <v-btn text icon x-small
              color="grey"
             @click="openStallDialog(item.stall_id)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn> -->
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(action, i) in actions"
                      :key="i"
                      @click="handleDynamicFunctionCall(action, item)"
                    >
                      <v-list-item-title>{{ action.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
          </template>

          <!-- Market Date -->
          <template v-slot:item.market_date="{ item }">
            {{ formatDate(item.market_date) }}
          </template>

          <!-- Stallholder Type -->
          <template v-slot:item.type="{ item }">
            <stallholder-type-icon v-if="isBooked(item) && item.type" :type="item.type"></stallholder-type-icon>
          </template>

          <!-- Stallholder Name -->
          <template v-slot:item.stallholder="{ item }">
            <mailto-btn :email="item.email"></mailto-btn>
            {{ item.stallholder }}
          </template>

          <!-- Paid status -->
          <template v-slot:item.is_paid="{ item }">
            <paid-status :item="item"></paid-status>
          </template>

          <!-- Cancelled Status -->
          <template v-slot:item.is_cancelled="{ item }">
            <cancelled-status :item="item"></cancelled-status>
          </template>

           <template v-slot:item.status_info="{ item }">
            <v-tooltip v-for="(icon, i) in item.status_icons" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click="handleFunctionCall(icon.action, icon.params)" v-on="on" :color="icon.color? icon.color : '' " class="mx-1">{{icon.icon}}</v-icon>
              </template>
              <span>{{icon.tooltip}}</span>
            </v-tooltip>
          </template>

          <!-- Deleted Date -->
          <template v-slot:item.deleted_date="{ item }">
            {{ formatDate(item.deleted_date) }}
          </template>

          <template v-slot:top>
          </template>
        </v-data-table>
      </v-card>

      <!-- <StallModal
        :dialogVisible="isStallDialogVisible"
        :selectedId="selectedStallId"
        @close="closeStallDialog"
      /> -->

      <ConfirmationDialog
        :dialogVisible="confirmationDialog.show"
        :text="confirmationDialog.text"
        :heading="confirmationDialog.heading"
        @cancel="closeConfirmationDialog"
        @confirm="deleteBooking"
      />

      <v-dialog
        v-model="alertDialog.show"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span>{{alertDialog.heading}}</span>
            <div class="flex-grow-1"></div>
          </v-card-title>
          <v-card-text v-html="alertDialog.text">
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="alertDialog.show = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="isSaving" z-index="1000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>


  </div>
</template>

<script>

import axios from 'axios';
import BookingModal from '../components/BookingModal';
import StallModal from '../components/StallModal';
import ConfirmationDialog from '../components/ConfirmationDialog';
import { mapGetters } from 'vuex'
import bookingsTableMixin from '../js/bookingsTableMixin';
import PaidStatus from '../components/PaidStatus';
import CancelledStatus from '../components/CancelledStatus';
import StallholderTypeIcon from '../components/StallholderTypeIcon';
import MailtoBtn from '../components/MailtoBtn';
import { formatDate } from '../js/helpers'


export default {
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Market Date',
          align: 'right',
          value: 'market_date',
          sortable: true
        },
         {
          text: 'Stall',
          align: 'left',
          value: 'name',
        },
        { text: 'Type', value: 'type', width: '80px'},
        { text: 'Stallholder Business Name (at time of booking)', value: 'stallholder' },
        { text: 'Stallholder Category', value: 'stallholder_category' },
        { text: 'Cancelled', value: 'is_cancelled', sortable: true, align: 'center', width: '120px'},
        { text: 'Paid', value: 'is_paid',  sortable: true, align: 'center', width: '120px' },
        { text: '', value: 'status_info', sortable: false, align: 'right'},
        { text: 'Deleted Date', value: 'deleted_date', sortable: true, align: 'right'},
        { text: '', value: 'actions', sortable: false, align: 'right',  width: '50px'}
      ],
      actions: [
        { title: 'Booking Details', function: 'openBookingDialog', params: ['booking_id'] },
      ],
      data : [],
      bookingData: [],
      isLoading: false,
      isStallDialogVisible: false,
      selectedStallId: false,
      selectedBookingId: false,
      filter: {
        isDeleted: 0,
        isDefaults: 0,
      },
      confirmationDialog: {
        show: false,
        heading: 'Delete Booking',
        text: ''
      },
      alertDialog: {
        show: false,
        heading: '',
        text: ''
      },
      isSaving: false
    }
  },
  props: {
    stallholder_id: {
      type: Number,
      required: false,
    },
    payment_id: {
      type: Number,
      required: false,
    },
  },
  mixins: [ bookingsTableMixin ],
  components: {
    BookingModal,
    StallModal,
    ConfirmationDialog,
    PaidStatus,
    CancelledStatus,
    StallholderTypeIcon,
    MailtoBtn
  },
  methods: {
    isBooked(stall) {
      return stall.booking_id ? true : false
    },
    getBookings(){
      let self=this;

      this.isLoading = true;

      let query = '';

      if(this.stallholder_id)
        query = `/wisdom-markets/v1/bookings?stallholder_id=${this.stallholder_id}`
      else if(this.payment_id)
        query = `/wisdom-markets/v1/bookings?payment_id=${this.payment_id}`
      else 
        return false

      axios.get(query, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.accessToken}`,
          },
        })
        .then(function (response) {
            console.warn('lili', response);

            let data = response.data;
            
            self.bookingData = data; // replace all old posts with new results
            self.$store.commit('setBookings', data);
            self.isLoading = false
        })
        .catch(function (error) {
            console.log(error);
            console.log("why thefick!!!");
        })
        .then(function () {
            // always executed
        });  
    },
    openDeleteConfirmation(id) {
      this.selectedBookingId = id;
      this.confirmationDialog.text = `Are you sure you want to delete the booking for <strong>${this.selectedBooking.stallholder_stall_name}</strong> in stall <strong>${this.getStallName(this.selectedBooking.stall_id)}</strong>?`
      this.confirmationDialog.show = true
    },
    closeConfirmationDialog (payload) {
      this.confirmationDialog.show = false
    },
    deleteBooking(id) {
      console.log("need to delete here booking id = "+this.selectedStallId);
      console.warn(this.selectedBooking);
      this.isSaving = true;
      axios({
        method: 'DELETE',
        url: `/wisdom-markets/v1/bookings/${this.selectedBooking.id}`,
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        //data: { is_deleted: 1 }
      })
      .then(response => {
          console.log("deleted", response);
          this.isSaving = false;
          this.confirmationDialog.show = false
          this.selectedBookingId = false;
          this.updateBooking(response.data);
      })
      .catch( (error, res) => {
          this.isSaving = false;
          this.alertDialog.heading = "Error!"
          this.alertDialog.text = `Cannot delete booking: ${error.message}`
          this.alertDialog.show = true;
          // self.savingDialog = false;
      });

    },
    handleDynamicFunctionCall(action, item) {
        let params = action.params.map(param => {
            return item[param];
        })
        this[action.function](...params)
    },
    handleFunctionCall(action, params) { console.warn({action}); console.warn({params})
      this[action](...params)
    },
    openBookingDialog(id) {
        this.$store.commit('setSelected', { 'item': 'bookingId', 'value': id})
        this.$store.commit('setDialogVisibility', { 'dialog': 'booking', 'value': true})
    },
    formatDate(date){
        return formatDate(date);
    },
  },
  computed: {
     ...mapGetters([
      'getStallholderById',
      'getStallName' // this is only used incase the stall name gets updated we want the bookings/market list to be auto updated
    ]),
    tableData(){

      return this.bookingData.map( item => {
        item.name = this.getStallName(item.stall_id); console.log(`looking for ${item.id}`)
        item.stallholder = item.title;
        item.booking_id = item.id;
        item.stallholder = `${item.stallholder_stall_name} (${item.first_name} ${item.last_name})`;

        if(this.payment_id) {
          item.type='casual';
          
          if(item.stallholder_id) {
            let stallholder = item.stallholder_id ? this.getStallholderById(item.stallholder_id) : false;
            item.type='';
            if(stallholder) {
              item.type=stallholder.stallholder_type;
            }
          }
        }

        item.status_icons = [];
        if(item.admin_note){
          item.status_icons.push({
            icon: 'mdi-message-text-outline',
            action: 'openBookingDialog',
            params: [item.booking_id],
            tooltip: 'Booking Admin Note',
            color: 'red lighten-2'
          });
        }

        return item;
        
      }).filter( item => {
        if(this.filter.isDeleted){
            return item.deleted_date ? true : false
        }else{
            return item.deleted_date ? false : true
        }
      });

    },
    selectedBooking() {
       let booking = this.bookingData.find( booking => this.selectedBookingId == booking.id)

      // let booking = this.bookingData.find( booking => this.selectedStallId == booking.stall_id)

      // // if no booking found or its a 'deleted' booking AND we are not currently looking at deleted booking
      // if(!booking || (booking.deleted_date != null && !this.filter.isDeleted)) return false
      
      return booking
    },
    tableHeaders() {

      return this.headers.filter(item => {

        if(item.value=='stallholder_category' && !this.filter.isDefaults)
          return false

        if(!this.filter.isDeleted && item.value=='deleted_date')
          return false

        if(!this.payment_id && item.value=='type')
          return false


        return true
      })
    },
    title(){
      if(this.stallholder_id)
        return 'Stallholder Bookings';
      else if(this.payment_id)
        return 'Payment Bookings';
      else
        return 'Bookings';
    },
  },
  mounted(){

    this.getBookings();

    //this.$store.dispatch('getStallholders', { });
    if(!this.$store.state.have_stalls)
      this.$store.dispatch('fetchStallData', { });

    //this.$store.dispatch('getStallholderCategories', { });
  }
}
</script>

<style>

</style>